import { render, staticRenderFns } from "./newcoper.vue?vue&type=template&id=9887848c&scoped=true&"
import script from "./newcoper.vue?vue&type=script&lang=js&"
export * from "./newcoper.vue?vue&type=script&lang=js&"
import style0 from "./newcoper.vue?vue&type=style&index=0&id=9887848c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9887848c",
  null
  
)

export default component.exports